import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';
import { ClientService } from '@app/core/client.service';
import { tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-client-name',
  template: `
    {{ renderValue }}
  `
})
export class ClientNameComponent implements OnInit, ViewCell {
  @Input() value: any;
  @Input() rowData: any;

  public renderValue: string;

  constructor(private clientService: ClientService) {}

  ngOnInit() {
    this.clientService.data$
      .pipe(
        tap(data => {
          for (let index = 0; index < data.length; index++) {
            if (this.value === data[index].idCliente) {
              this.renderValue = data[index].name;
              break;
            }
          }
        })
      )
      .subscribe();
  }
}
